export default __webpack_public_path__ + "static/media/Privacy-Policy.45ce1709.jpg";